import instance from './axios-instance'

export const getAllParentCategories = async () => {
  const { data } = await instance.get('/api/v1/parentCategory')
  return data
}
export const createParentCategory = async ({ name = 'new Category' }) => {
  const { data } = await instance.post('/api/v1/admin/parentCategory', { name })
  return data
}
export const getParentCategoryAttributes = async (id) => {
  const { data } = await instance.get(`/api/v1/parentCategory/${id}/attribute`)
  return data
}
export const getParentCategory = async (id) => {
  const { data } = await instance.get(`/api/v1/parentCategory/${id}`)
  return data
}
